<template>
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Nama Pelanggan</th>
        <th scope="col">NO. Telepon</th>
        <th scope="col">Total Withdraw</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in items"
        :key="item.uuid"
      >
        <td>{{ item.subject && item.subject.name || '-' }}</td>
        <td>{{ item.subject && item.subject.phone_number || '-' }}</td>
        <td>{{ formatToRupiah(item.amount) }}</td>
      </tr>
    </tbody>
    <tbody v-if="items.length === 0">
        <tr>
          <td
            colspan="4"
            class="text-center"
          >
            Data kosong.
          </td>
        </tr>
      </tbody>
  </table>
</template>

<script>
export default {
  name: 'WithdrawDeposit',
  props: ['items'],
  methods: {
    formatToRupiah(amount) {
      const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      });
      return formatter.format(amount ?? 0).toString().replace('-', '');
    },
  },
};
</script>
